import { format } from 'date-fns';
import React from 'react';
import styles from './Contacts.module.scss';

const AddedOn = ({ data }) => {
  const source = data.source
    ? data.source.charAt(0).toUpperCase() + data.source.slice(1)
    : 'Unknown';

  const date = format(new Date(data.inserted_timestamp), 'eeee, MMM dd, yyyy');

  return (
    <div className={styles.added_wrapper}>
      <span>{date}</span>
      <span>via {source}</span>
    </div>
  );
};

export default AddedOn;
